module.exports = __webpack_public_path__ + "media/upwise/right-arrow-7c454a08.svg";